import { Button } from '../../components/ui/button';

export const AuditLogTab = ({ auditLog, onRefresh }) => {
  return (
    <div className="space-y-4" data-testid="admin-audit-tab">
      <div className="flex justify-between items-center">
        <h3 className="font-outfit text-lg font-semibold text-[#0B3D91]">Activity Log</h3>
        <Button variant="outline" onClick={onRefresh} size="sm" data-testid="audit-refresh-btn">Refresh</Button>
      </div>
      <div className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full" data-testid="admin-audit-log">
            <thead className="bg-slate-50 border-b border-slate-200">
              <tr>
                <th className="text-left p-4 text-xs font-semibold text-slate-500 uppercase tracking-wider">Action</th>
                <th className="text-left p-4 text-xs font-semibold text-slate-500 uppercase tracking-wider">Admin</th>
                <th className="text-left p-4 text-xs font-semibold text-slate-500 uppercase tracking-wider">Target</th>
                <th className="text-left p-4 text-xs font-semibold text-slate-500 uppercase tracking-wider">Details</th>
                <th className="text-left p-4 text-xs font-semibold text-slate-500 uppercase tracking-wider">Time</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {auditLog.length === 0 ? (
                <tr><td colSpan="5" className="p-8 text-center text-slate-400">No audit logs yet</td></tr>
              ) : auditLog.map((log, idx) => (
                <tr key={idx} className="hover:bg-slate-50/50">
                  <td className="p-4">
                    <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${
                      log.action.includes('delete') ? 'bg-red-100 text-red-700' :
                      log.action.includes('role') ? 'bg-purple-100 text-purple-700' :
                      log.action.includes('permission') ? 'bg-blue-100 text-blue-700' :
                      'bg-slate-100 text-slate-600'
                    }`}>
                      {log.action.replace(/_/g, ' ')}
                    </span>
                  </td>
                  <td className="p-4 text-sm text-slate-600">{log.admin_email}</td>
                  <td className="p-4 text-sm text-slate-600">{log.target_email || log.app_id || '-'}</td>
                  <td className="p-4 text-sm text-slate-500">
                    {log.old_role && log.new_role ? `${log.old_role} -> ${log.new_role}` : ''}
                    {log.app_id && !log.old_role ? log.app_id : ''}
                  </td>
                  <td className="p-4 text-xs text-slate-400">
                    {log.created_at ? new Date(log.created_at).toLocaleString() : '-'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
